export { formatBytes, formatDuration, formatName, KIND_LABELS } from '../../shared/formats';

const dateFmt = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const timeFmt = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' });

export const formatDate = (iso: string | null | undefined) => (iso ? dateFmt.format(new Date(iso)) : '–');
export const formatDateTime = (iso: string | null | undefined) =>
  iso ? dateTimeFmt.format(new Date(iso)) : '–';

/** "gerade eben", "vor 5 Min.", "heute 14:02", "gestern", sonst Datum. */
export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '–';
  const date = new Date(iso);
  const diff = Date.now() - date.getTime();
  if (diff < 60_000) return 'gerade eben';
  if (diff < 3600_000) return `vor ${Math.floor(diff / 60_000)} Min.`;
  const today = new Date();
  if (date.toDateString() === today.toDateString()) return `heute ${timeFmt.format(date)}`;
  const yesterday = new Date(today.getTime() - 86400_000);
  if (date.toDateString() === yesterday.toDateString()) return `gestern ${timeFmt.format(date)}`;
  return dateFmt.format(date);
}

export function formatTimecode(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '';
  const s = Math.max(0, ms) / 1000;
  const m = Math.floor(s / 60);
  return `${m}:${(s % 60).toFixed(1).padStart(4, '0')}`;
}

export function initials(name: string): string {
  const parts = name
    .trim()
    .split(/[\s@._-]+/)
    .filter(Boolean);
  return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase();
}

export function pluralize(count: number, one: string, many: string): string {
  return `${count} ${count === 1 ? one : many}`;
}
